<section>
  <div class="form-register">
    <form [formGroup]="formMaintenanceOrderSupplies">
      <div class="row p-1">
        <div class="col-lg-6 col-md-10 col-sm-12 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
            [required]="true"></app-custom-autocomplete>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-12 col-12">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-5 col-sm-6 col-12 d-flex mt-2">
          <div class="d-flex align-items-end justify-content-end gap-1 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>